import { useEffect, useState } from "react";

import { listCertifications } from "@/utils/certifications.functions";
import type { Certification } from "@/lib/training-pipeline";

interface CertificationsState {
  certifications: Certification[];
  loading: boolean;
  error: string | null;
}

/** Loads certifications from the Training Pipeline API through the server. */
export function useCertifications(): CertificationsState {
  const [state, setState] = useState<CertificationsState>({
    certifications: [],
    loading: true,
    error: null,
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const result = await listCertifications();
        if (cancelled) return;
        if ("error" in result) {
          setState({ certifications: [], loading: false, error: result.error });
          return;
        }
        setState({ certifications: result.certifications, loading: false, error: null });
      } catch {
        if (!cancelled) {
          setState({
            certifications: [],
            loading: false,
            error: "We couldn't load the certifications right now. Please try again shortly.",
          });
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
